// Minimal gold bar strip for per-week player points. Pure SVG, no axes.
import React from 'react';

interface Props {
  values: { x: number; y: number }[];
  height?: number;
  ariaLabel: string;
}

const W = 240;

const Sparkline: React.FC<Props> = ({ values, height = 36, ariaLabel }) => {
  if (values.length === 0) return null;
  const H = height;
  const yMax = Math.max(1, ...values.map(v => v.y));
  const slot = W / values.length;
  const barW = Math.max(2, Math.min(10, slot * 0.6));

  return (
    <svg viewBox={`0 0 ${W} ${H}`} width="100%" role="img" aria-label={ariaLabel}>
      {values.map((v, i) => {
        const h = Math.max(v.y > 0 ? 2 : 1, (v.y / yMax) * (H - 4));
        return (
          <rect
            key={v.x}
            x={slot * i + (slot - barW) / 2}
            y={H - h}
            width={barW}
            height={h}
            fill={v.y > 0 ? '#F4B400' : '#CFCDC6'}
          >
            <title>{`W${v.x}: ${v.y}`}</title>
          </rect>
        );
      })}
    </svg>
  );
};

export default Sparkline;
